import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

// Date time utilities.
import { date, dateTime } from '@exonet/jsonapi-data-collections/lib/dataObjects/types/attributes';

// React-select.
import DateRangePicker from '@exonet/react-shared/lib/Elements/DateRangePicker';

// Hooks.
import useNumberOfMonths from 'app/client/components/Filters/FilterRange/hooks/useNumberOfMonths';

const FilterRange = ({
  onChange,
  disabled,
  name = 'range',
  value = null,
  disabledAfter = undefined,
  clearable = true,
  dateOnly = false,
  placeholder,
  locale,
}) => {
  const numberOfMonths = useNumberOfMonths();

  /**
   * Handle the change of the date range filter.
   *
   * @param {Object} dates The current value of the from and to dates.
   */
  const handleRangeChange = useCallback(
    (dates) => {
      const { from, to } = dates;
      if (from === undefined || to === undefined) {
        onChange(name, null);
        return;
      }
      const attribute = dateOnly ? date : dateTime;

      const fromDate = attribute();
      fromDate.set(from);

      const toDate = attribute();
      toDate.set(to);

      onChange(name, [fromDate.api(), toDate.api()]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChange, dateOnly],
  );

  const fromDate = value !== null && value[0] !== undefined ? new Date(value[0]) : undefined;

  const toDate = value !== null && value[1] !== undefined ? new Date(value[1]) : undefined;

  return (
    <DateRangePicker
      onChange={handleRangeChange}
      disabled={disabled}
      fromDate={fromDate}
      toDate={toDate}
      numberOfMonths={numberOfMonths}
      disabledAfter={disabledAfter}
      clearable={clearable}
      placeholder={placeholder}
      locale={locale}
    />
  );
};

FilterRange.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  disabledAfter: PropTypes.instanceOf(Date),
  clearable: PropTypes.bool,
  dateOnly: PropTypes.bool,
  placeholder: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
  }),
  locale: PropTypes.object,
};

export default FilterRange;
